import { render, staticRenderFns } from "./PdpDefault.vue?vue&type=template&id=41a8451b&scoped=true&"
import script from "./PdpDefault.vue?vue&type=script&lang=js&"
export * from "./PdpDefault.vue?vue&type=script&lang=js&"
import style0 from "./PdpDefault.vue?vue&type=style&index=0&id=41a8451b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a8451b",
  null
  
)

export default component.exports